import { Box, styled } from '@mui/material';
export const TokenContainer = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 40,
}));
//# sourceMappingURL=RouteCard.style.js.map